import { FC } from 'react'
import { utils } from 'utils'
import LinkPreviewItem from './LinkPreview'

const ChatMsgTextItem: FC<{
 text?: string
 isSender?: boolean
}> = ({ text, isSender }) => {
 if (text && utils.isValidURL(text ?? '')) {
  return <LinkPreviewItem link={text} isSender={isSender} />
 }

 return <span className="chat-text">{text}</span>
}

export default ChatMsgTextItem
